/**
 * GlitchTip Error Tracking - Inicialização
 *
 * Este arquivo DEVE ser importado ANTES de qualquer outro código React.
 * GlitchTip é compatível com o SDK do Sentry (versões básicas).
 *
 * DSN: https://a05de71ec3c94ca8bf861d91e1097887@erros.2ecomp.com.br/1
 * Painel: https://erros.2ecomp.com.br
 *
 * NOTA: GlitchTip NÃO suporta todas as features do Sentry:
 * - Session Replay: NÃO suportado
 * - Performance Tracing: Suporte limitado
 *
 * @see /opt/traccar/docs/GLITCHTIP.md para documentação completa
 */
import * as Sentry from "@sentry/react";

// Detecta se estamos em desenvolvimento
const isDev = import.meta.env.MODE === 'development';

// Configuração do GlitchTip (compatível com Sentry SDK básico)
Sentry.init({
    // DSN do GlitchTip - tracker-2ecomp
    dsn: "https://a05de71ec3c94ca8bf861d91e1097887@erros.2ecomp.com.br/1",

    // Ambiente: development, staging, production
    environment: import.meta.env.MODE || 'production',

    // Release - usa a versão do package.json
    release: `traccar-web@${import.meta.env.VITE_APP_VERSION || '6.12.2'}`,

    // Desabilita em desenvolvimento para não poluir o GlitchTip
    enabled: !isDev,

    // Taxa de amostragem para traces (performance)
    // GlitchTip tem suporte limitado, usar taxa baixa
    tracesSampleRate: 0.1,

    // DESABILITADO: GlitchTip NÃO suporta Session Replay
    // replaysSessionSampleRate: 0,
    // replaysOnErrorSampleRate: 0,

    // Integrações - apenas as básicas suportadas pelo GlitchTip
    integrations: [
        // Rastreamento básico de performance
        Sentry.browserTracingIntegration({
            // Desabilita instrumentação automática que pode causar problemas
            enableInp: false,
        }),
        // NÃO incluir replayIntegration - GlitchTip não suporta
    ],

    // Hooks de antes de enviar - útil para filtrar dados sensíveis
    beforeSend(event) {
        // Remove tokens de autenticação dos breadcrumbs
        if (event.breadcrumbs) {
            event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {
                if (breadcrumb.data?.url) {
                    // Remove tokens de URLs
                    breadcrumb.data.url = breadcrumb.data.url.replace(/token=[^&]+/g, 'token=[REDACTED]');
                }
                return breadcrumb;
            });
        }
        return event;
    },

    // Ignora erros comuns que não são úteis
    ignoreErrors: [
        // Erros de rede comuns
        'Network request failed',
        'Failed to fetch',
        'Load failed',
        // Erros de extensões de navegador
        'ResizeObserver loop limit exceeded',
        // Erros de script bloqueado
        'Script error.',
        // Erros do MapLibre (tiles malformados)
        'Expected value to be of type number',
        // Erros de portas desconectadas (React DevTools)
        'disconnected port object',
    ],
});

// Exporta o Sentry para uso em outros arquivos
export { Sentry };
